module.exports = __webpack_public_path__ + "img/car-club-colored.3b24188d.svg";